import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-1 px-1 px-lg-2 px-xl-3 address-btn" }
const _hoisted_2 = { class: "d-flex align-center account-address" }
const _hoisted_3 = { class: "d-none d-lg-inline ml-1 ml-lg-2" }
const _hoisted_4 = { class: "d-flex ga-1 align-center pl-2 pl-lg-3 pr-2 balance" }
const _hoisted_5 = ["textContent"]

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useDisplay } from "vuetify";

import { AETERNITY_SYMBOL, ROUTE_ACCOUNT_DETAILS } from "@/utils/constants";
import { formatAddress, formatFractionalPrice } from "@/utils";
import { useAeBalance, useWalletConnect } from "@/composables";
import { useAccounts } from "@/stores";

import AddressAvatar from "@/components/Common/AddressAvatar.vue";
import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveAccountBtn',
  setup(__props) {

const { smAndDown } = useDisplay();
const { activeAccount } = storeToRefs(useAccounts());
const { scanningForAccounts } = useWalletConnect();

const { aeBalance, aeBalanceLoaded, aeBalanceLoading } = useAeBalance();

const isBalanceStillLoading = computed(
  () =>
    scanningForAccounts.value ||
    (aeBalanceLoading.value && !aeBalanceLoaded.value)
);

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_unref(activeAccount))
    ? (_openBlock(), _createBlock(_component_v_btn, {
        key: 0,
        class: "active-account-btn d-flex align-center pa-1 rounded-lg",
        variant: "tonal",
        active: false,
        to: { name: _unref(ROUTE_ACCOUNT_DETAILS), params: { address: _unref(activeAccount) } }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AddressAvatar, {
                address: _unref(activeAccount),
                size: 26
              }, null, 8, ["address"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatAddress)(_unref(activeAccount))), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (isBalanceStillLoading.value)
              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                  key: 0,
                  size: "18",
                  width: "2",
                  indeterminate: ""
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(smAndDown))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        textContent: _toDisplayString(_unref(aeBalance)?.shorten())
                      }, null, 8, _hoisted_5))
                    : (_openBlock(), _createBlock(FractionFormatter, {
                        key: 1,
                        "fractional-price": _unref(formatFractionalPrice)(_unref(aeBalance))
                      }, null, 8, ["fractional-price"])),
                  _createTextVNode(" " + _toDisplayString(_unref(AETERNITY_SYMBOL)), 1)
                ], 64))
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})